import type Store from "@ember-data/store";
import type ApplicationInstance from "@ember/application/instance";
import type TherapeuticalArea from "parog-web/models/therapeutical-area";

export function initialize(owner: ApplicationInstance): void {
  const store = owner.lookup("service:store") as Store;

  const nephro = store.peekRecord("therapeutical-area", "nephro");
  const pneumo = store.peekRecord("therapeutical-area", "pneumo");
  const cardio = store.peekRecord("therapeutical-area", "cardio");
  const hepato = store.peekRecord("therapeutical-area", "hepato");
  const onco = store.peekRecord(
    "therapeutical-area",
    "onco"
  ) as TherapeuticalArea;

  const data = {
    "articular-pain": [onco],
    bleeding: [onco],
    blotch: [cardio],
    breathlessness: [cardio],
    "changing-mood": [onco],
    constipation: [onco],
    confusion: [cardio],
    cough: [nephro, pneumo, hepato, onco],
    "chest-pain": [cardio],
    diarrhea: [nephro, pneumo, hepato, onco],
    "discomfort-when-changing-position": [cardio],
    fatigue: [onco],
    fever: [nephro, pneumo, hepato, onco],
    flush: [onco],
    headache: [onco],
    lackappetite: [cardio],
    weightinc: [cardio],
    "mouth-ulcers": [onco],
    "nail-infection": [onco],
    nausea: [nephro, pneumo, hepato, onco],
    oedema: [onco, cardio],
    "palmar-plantar": [onco],
    palpitation: [cardio],
    "redness-itching": [onco],
    "respiratory-difficulty": [nephro, pneumo, hepato],
    shiver: [nephro, pneumo, hepato],
    "skin-rash": [onco],
    "sleep-disorders": [onco],
    "spit-change": [nephro, pneumo, hepato],
    vertigo: [cardio],
    vomiting: [nephro, pneumo, hepato, onco],

    other: [nephro, pneumo, hepato, onco]
  };

  Object.entries(data).forEach(([id, therapeuticalAreas]) => {
    store.createRecord("adverse-event", {
      id,
      therapeuticalAreas
    });
  });
}

export default {
  after: "follow-up-reasons",
  initialize
};
